import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import styled from 'styled-components';
import EyeOutlineIcon from 'mdi-react/EyeOutlineIcon';

import { xcriticalModalOpen } from '@xcritical/modal';

import { IconButton } from '@crm-framework/icon-button';
import { TextTruncate } from '@crm-framework/utils';

import { LEAD_PREVIEW_MODAL } from '../consts';

interface IColumnWithPreviewProps {
  value: string;
  width?: number;
}

const DescriptionWrapper = styled.div<{ width?: number }>`
  display: flex;
  gap: 5px;
  align-items: center;
  width: ${({ width }) => (width ? `${width}px` : 'inherit')};
  text-overflow: ellipsis;
`;

export const ColumnWithPreview: React.VFC<IColumnWithPreviewProps> = ({
  value,
  width,
}) => {
  const dispatch = useDispatch();
  const onClick = useCallback(() => {
    dispatch(xcriticalModalOpen(LEAD_PREVIEW_MODAL, { value }));
  }, [value]);

  return (
    <DescriptionWrapper width={width}>
      <IconButton icon={EyeOutlineIcon} onClick={onClick} />
      <TextTruncate>{value}</TextTruncate>
    </DescriptionWrapper>
  );
};

export const renderPreviewColumn = (value: string) =>
  value ? <ColumnWithPreview value={value} /> : <></>;
